module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseInput', {
    attrs: {
      "error": _vm.error,
      "required": _vm.required
    }
  }, [_c('template', {
    slot: "label"
  }, [(_vm.validator === _vm.FORM_VALIDATORS.color) ? _c('span', {
    staticClass: "color-circle",
    style: ({
      backgroundColor: _vm.value
    })
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('template', {
    slot: "input"
  }, [_c('div', {
    staticClass: "input-div"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "minlength": _vm.minLength || false,
      "maxlength": _vm.maxLength || false,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": _vm.blurListener,
      "input": _vm.inputListener
    }
  }), _vm._v(" "), (_vm.counter) ? _c('span', {
    staticClass: "counter",
    class: {
      counter__full: _vm.counterError
    }
  }, [_vm._v(_vm._s(_vm.counter))]) : _vm._e()])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df9171e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/TextInputBloc.vue
// module id = 3291
// module chunks = 0